
import { Component, Prop, Vue } from "vue-property-decorator";
import Multiselect from "vue-multiselect";
import { ValidationProvider } from "vee-validate";
import { IFault } from "@/entities";
import { Getter } from "vuex-class";
import { Locale } from "@/store";
import HelpAdviseForm from "@/components/orders/HelpAdviseForm.vue";

@Component({
  name: "assistance-service-form",
  components: {
    Multiselect,
    ValidationProvider,
    HelpAdviseForm,
  },
})
export default class AssistanceServiceForm extends Vue {
  @Getter("getLocale") locale!: Locale;
  @Prop({ required: true })
  serviceDate!: Date;
  @Prop({ required: false, default: false })
  allowIntervalTime!: boolean;
  @Prop({ required: false })
  initialTime!: string;
  @Prop({ required: false })
  finalTime!: string;
  @Prop({ required: false, default: 2 })
  minimunIntervalTime!: number;
  @Prop({ required: false, default: 1 })
  minimunStartingInterval!: number;
  @Prop({ required: false, default: 8 })
  minimunHour!: number;
  @Prop({ required: false, default: 18 })
  maximunHour!: number;
  minDate: Date = new Date();

  @Prop({ required: true, default: [] })
  faults!: IFault[];
  @Prop({ required: true })
  fault!: IFault | null;
  @Prop({ required: true })
  comments!: string;

  constructor() {
    super();
  }

  mounted(): void {
    const now = new Date();
    this.minDate = new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate()));
  }

  get _serviceDate(): Date {
    return this.serviceDate;
  }

  set _serviceDate(value: Date) {
    this.$emit("update:serviceDate", value);
  }

  get _fault(): IFault | null {
    return this.fault;
  }

  set _fault(value: IFault | null) {
    this.$emit("update:fault", value);
  }

  get _initialTime(): string {
    return this.initialTime;
  }

  set _initialTime(value: string) {
    this.$emit("update:initialTime", value);
  }

  get _finalTime(): string {
    return this.finalTime;
  }

  set _finalTime(value: string) {
    this.$emit("update:finalTime", value);
  }

  get _comments(): string {
    return this.comments;
  }
  set _comments(value: string) {
    this.$emit("update:comments", value);
  }
}
